import { FieldPath } from 'react-hook-form';

import { ThemeSetAttributes } from 'dashboard/models/theme-set';
import {
  THEME_SET_FORM_COMPONENT_CATEGORIES,
  ThemeSetEditorFormControlConfig,
} from 'dashboard/views/DashboardThemeSetsEditorNewView/theme-set-editor-form-categories';
import { isCombinedStep, StepPreview } from 'lib/interfaces/StepsConfig';

// Checks if the field value is an object and has a 'value' property
// Useful when the field value is expected to be a StyleValueColorConfig or StyleValueSizeConfig
export const getValueFromObject = (fieldValue: any) => {
  if (fieldValue && typeof fieldValue === 'object' && 'value' in fieldValue) {
    return fieldValue.value;
  }
  return '';
};

// Checks if the field value is an object and has a 'unit' property
// Useful when the field value is expected to be a StyleValueSizeConfig
export const getUnitFromObject = (fieldValue: any) => {
  if (fieldValue && typeof fieldValue === 'object' && 'unit' in fieldValue) {
    return fieldValue.unit;
  }
  return '';
};

const ALL_THEME_SET_CONTROLS = THEME_SET_FORM_COMPONENT_CATEGORIES.reduce(
  (controls, currCategory) => {
    controls.push(...currCategory.controls);
    currCategory.subCategories?.forEach((subCategory) => {
      controls.push(...subCategory.controls);
    });
    return controls;
  },
  [] as ThemeSetEditorFormControlConfig[],
);

// Gets the label of the field from THEME_SET_FORM_COMPONENT_CATEGORIES
export const getFieldLabel = (fieldName: FieldPath<ThemeSetAttributes>) => {
  return ALL_THEME_SET_CONTROLS.find((control) => control.name === fieldName)?.label;
};

// maps preview page to the step index in stepsPreview
export const findPreviewStepsIndexToUpdate = (
  stepsPreview: StepPreview[],
  pages: React.ReactElement[],
  slideNumber: number,
): number[] => {
  const currentPageKey = pages[slideNumber]?.key;
  let currentStepIndex = 0;
  // device handoff gets their styles from the first combined step of the stepsPreview
  if (currentPageKey?.startsWith('device-handoff')) {
    currentStepIndex = stepsPreview.findIndex((step) => isCombinedStep(step));
  } else {
    currentStepIndex = stepsPreview.findIndex(
      (step) => step.name === currentPageKey?.split('-')[0],
    );
  }
  return [
    Math.max(currentStepIndex - 2, 0),
    Math.min(currentStepIndex + 2, stepsPreview.length - 1),
  ];
};
